import { createColor } from '@manakin/theme/lib/color';

const beautyTertiary = createColor('#F28F7F');

export default beautyTertiary;
